/* Dogfluence conversion enhancements
   1. Split option selectors that drive the existing combined variant buttons.
   2. Mobile sticky Add to Bag bar that forwards to the real button.
   3. Short shipping line under the stock line, next to the price.
   All are additive: assets/dogfluence.js remains the only cart code path. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function initOptionPicker() {
    var picker = document.querySelector('[data-option-picker]');
    if (!picker) return;

    var variantButtons = Array.prototype.slice.call(document.querySelectorAll('[data-variant-select]'));
    if (!variantButtons.length) return;

    var variants = variantButtons.map(function (btn) {
      return {
        btn: btn,
        values: (btn.getAttribute('data-variant-options') || '').split('||'),
        available: !btn.disabled
      };
    });

    var groups = Array.prototype.slice.call(picker.querySelectorAll('[data-option-group]'));

    function valuesIn(group) {
      return Array.prototype.slice.call(group.querySelectorAll('.option-value'));
    }

    function currentSelection() {
      return groups.map(function (g) {
        var active = g.querySelector('.option-value.variant-active');
        return active ? active.getAttribute('data-option-value') : null;
      });
    }

    function matching(selection) {
      return variants.filter(function (v) {
        for (var i = 0; i < selection.length; i++) {
          if (selection[i] !== null && v.values[i] !== selection[i]) return false;
        }
        return true;
      });
    }

    function findVariant(selection) {
      var candidates = matching(selection);
      var inStock = candidates.filter(function (v) { return v.available; });
      return inStock[0] || candidates[0] || null;
    }

    function syncFrom(values) {
      if (!values) return;
      groups.forEach(function (g, i) {
        var val = values[i];
        var label = g.querySelector('[data-option-selected]');
        if (label && val) label.textContent = val;
        valuesIn(g).forEach(function (b) {
          var on = b.getAttribute('data-option-value') === val;
          b.classList.toggle('variant-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });
    }

    function markUnavailable() {
      var selection = currentSelection();
      groups.forEach(function (g, i) {
        valuesIn(g).forEach(function (b) {
          var trial = selection.slice();
          trial[i] = b.getAttribute('data-option-value');
          var any = matching(trial).some(function (v) { return v.available; });
          b.classList.toggle('option-unavailable', !any);
          if (any) { b.removeAttribute('aria-disabled'); } else { b.setAttribute('aria-disabled', 'true'); }
        });
      });
    }

    picker.addEventListener('click', function (e) {
      var button = e.target.closest ? e.target.closest('.option-value') : null;
      if (!button || !picker.contains(button)) return;
      var group = button.closest('[data-option-group]');
      var index = groups.indexOf(group);
      if (index < 0) return;

      var selection = currentSelection();
      selection[index] = button.getAttribute('data-option-value');

      var variant = findVariant(selection);
      if (variant) {
        // The existing handler in dogfluence.js does the real work.
        variant.btn.click();
        syncFrom(variant.values);
      } else {
        syncFrom(selection);
      }
      markUnavailable();
    });

    // If the gallery (arrows, thumbnails, swipe) changes the variant, mirror it here.
    if (window.MutationObserver) {
      var observer = new MutationObserver(function () {
        var active = variants.filter(function (v) { return v.btn.classList.contains('variant-active'); })[0];
        if (active) syncFrom(active.values);
        markUnavailable();
      });
      variantButtons.forEach(function (b) {
        observer.observe(b, { attributes: true, attributeFilter: ['class'] });
      });
    }

    markUnavailable();
  }

  function initStickyAddToBag() {
    var bar = document.querySelector('[data-sticky-atb]');
    var realButton = document.querySelector('[data-add-to-bag]');
    var actions = document.querySelector('.detail-actions');
    if (!bar || !realButton || !actions) return;

    var barButton = bar.querySelector('[data-sticky-atb-button]');
    var barPrice = bar.querySelector('[data-sticky-atb-price]');
    var barVariant = bar.querySelector('[data-sticky-atb-variant]');
    var realPrice = document.querySelector('[data-add-to-bag-price]');
    var legend = document.querySelector('[data-variant-legend]');

    // Oct 2026 (Clarity review): the bar used to appear only after the real
    // Add to Cart had scrolled UP out of view. Average scroll depth on the
    // site is ~40%, and on a phone the real button sits well below the first
    // screen, so most visitors never saw any way to buy. The bar now shows
    // whenever the real button is off screen in EITHER direction.
    //
    // Products with sizes or colours (data-needs-choice) show "Choose options"
    // until the shopper has touched an option or reached the real button, so
    // nobody adds the default size by accident. That button scrolls to the
    // options instead of adding to cart.
    var needsChoice = bar.hasAttribute('data-needs-choice');
    var hasChosen = false;
    var chooseMode = false;
    var buyPanel = document.querySelector('.product-buy-panel');

    document.documentElement.classList.add('df-has-sticky-atb');

    function optionsTarget() {
      return document.querySelector('[data-option-picker]') ||
        document.querySelector('.variant-picker:not(.variant-picker-hidden)') ||
        actions;
    }

    if (barButton) {
      barButton.addEventListener('click', function () {
        if (chooseMode) {
          var target = optionsTarget();
          var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
          return;
        }
        realButton.click();
      });
    }

    if (buyPanel && needsChoice) {
      buyPanel.addEventListener('click', function (e) {
        if (!e.target.closest) return;
        if (e.target.closest('.option-value, [data-variant-select], [data-colour-select]')) {
          hasChosen = true;
          evaluate();
        }
      });
    }

    function mirror() {
      if (barPrice && realPrice) barPrice.textContent = realPrice.textContent;
      if (barVariant && legend) barVariant.textContent = legend.textContent;
      if (barButton) barButton.disabled = chooseMode ? false : realButton.disabled;
    }

    if (window.MutationObserver) {
      var mo = new MutationObserver(mirror);
      if (realPrice) mo.observe(realPrice, { childList: true, characterData: true, subtree: true });
      if (legend) mo.observe(legend, { childList: true, characterData: true, subtree: true });
      mo.observe(realButton, { attributes: true, attributeFilter: ['disabled'] });
    }

    // A direct geometry check on every scroll frame, deliberately NOT an
    // IntersectionObserver: IO only fires when the intersection state CHANGES,
    // so a fast scroll or an anchor jump that takes .detail-actions straight
    // from above the viewport to below it never produces an intersecting state,
    // no callback fires, and the bar stays stuck open. Reading the rect is
    // cheap inside a rAF-throttled handler and is correct at every scroll
    // position, not just at transitions.
    var ticking = false;

    function evaluate() {
      var rect = actions.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      var above = rect.bottom < 0;
      var below = rect.top > viewportHeight;

      // Once the shopper has reached the real button they have seen the options.
      if (!below) hasChosen = true;

      if (above || below) {
        bar.removeAttribute('hidden');
      } else {
        bar.setAttribute('hidden', '');
      }

      chooseMode = needsChoice && below && !hasChosen;
      bar.classList.toggle('is-choose', chooseMode);
      mirror();
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        evaluate();
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    evaluate();
  }

  // Oct 2026 (Clarity review): shipping cost was only stated below the Add to
  // Cart button, which most phone visitors never reach. This adds one short
  // line beside the price. The threshold matches the free standard rate and
  // the $10 standard rate in snippets/dogfluence-ship-nudge.
  // 31 Oct 2026: threshold $149 (was $150) so the $149 bundle ships free.
  function initShipLine() {
    var stock = document.querySelector('.product-buy-panel .stock-line');
    var realButton = document.querySelector('[data-add-to-bag]');
    if (!stock || !realButton || document.querySelector('.detail-ship-line')) return;

    var price = parseInt(realButton.getAttribute('data-unit-price'), 10);
    if (isNaN(price)) return;

    var line = document.createElement('p');
    line.className = 'detail-ship-line';
    if (price >= 14900) {
      line.innerHTML = '<strong>Free standard shipping</strong> on this item';
    } else {
      line.innerHTML = '$10 standard shipping &middot; <strong>free from $149</strong>';
    }
    stock.parentNode.insertBefore(line, stock.nextSibling);
  }

  ready(function () {
    try { initShipLine(); } catch (e) {}
    try { initOptionPicker(); } catch (e) {}
    try { initStickyAddToBag(); } catch (e) {}
  });
})();
